import React from 'react';
import { styled } from '@linaria/react';

import { isError, isSubmitError } from '../../utils/validators';

const Error = styled.div`
  position: relative;
  color: var(--bb-error-color);
  font-size: var(--bb-error-font-size);
  padding-top: 6px;
  line-height: var(--bb-error-line-height);
  background-color: ${({ useDashboardDS }) =>
    useDashboardDS ? 'rgb(251, 233, 234)' : 'transparent'};
  border-radius: 3px;
  padding: ${({ useDashboardDS }) => (useDashboardDS ? '12px' : '0')};
  margin: ${({ useDashboardDS }) => (useDashboardDS ? '4px 0 0 0' : '0')};

  &::before {
    top: -4px;
    left: 24px;
    display: ${({ useDashboardDS }) => (useDashboardDS ? 'block' : 'none')};
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
    transform: rotate(45deg);
  }
`;

export const FieldError = ({ meta, useDashboardDS = false }) => {
  if (!isError(meta)) return null;

  return <Error useDashboardDS={useDashboardDS}>{meta.error || meta.submitError}</Error>;
};

export const FieldSubmitError = ({ meta, useDashboardDS = false }) => {
  if (!isSubmitError(meta)) return null;

  return <Error useDashboardDS={useDashboardDS}>{meta.error || meta.submitError}</Error>;
};
